<script>
// Iconsax "tick" (linear): só o traço, sem círculo — para listas de benefícios em que o
// `check-circle` pesava demais ao lado do texto. Um único `<path>` em stroke, sem ids.
export default {
  name: 'IconCheck',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 12.5L9.5 17L19 7"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
